const checkIfFromEmail = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const fromEmailParam = url.searchParams.get('fromemail');

  return JSON.parse(fromEmailParam);
};

module.exports = checkIfFromEmail;
